(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-youtube"] && !Shopify.designMode) return;
  try {
    
  function initializeMichelleWatch(scope) {
    scope.querySelectorAll('.mt-watch:not([data-ready])').forEach(function(section) {
      section.dataset.ready = 'true';
      const track = section.querySelector('.mt-watch__track');
      const cards = Array.from(track.querySelectorAll('.mt-watch__card'));
      const arrows = Array.from(section.querySelectorAll('[data-mt-direction]'));
      const reset = function(card) {
        const frame = card.querySelector('iframe');
        const link = card.querySelector('.mt-watch__play');
        if (frame) frame.remove();
        if (link) link.hidden = false;
      };
      const currentIndex = function() {
        let index = 0;
        let distance = Infinity;
        const left = track.getBoundingClientRect().left + parseFloat(getComputedStyle(track).paddingLeft);
        cards.forEach(function(card, i) {
          const delta = Math.abs(card.getBoundingClientRect().left - left);
          if (delta < distance) { index = i; distance = delta; }
        });
        return index;
      };
      const update = function() {
        const index = currentIndex();
        arrows.forEach(function(button) {
          button.disabled = Number(button.dataset.mtDirection) < 0 ? index === 0 : index === cards.length - 1;
        });
      };
      arrows.forEach(function(button) {
        button.addEventListener('click', function() {
          const index = Math.max(0, Math.min(cards.length - 1, currentIndex() + Number(button.dataset.mtDirection)));
          cards.forEach(reset);
          const card = cards[index];
          const padding = parseFloat(getComputedStyle(track).paddingLeft);
          track.scrollTo({left: track.scrollLeft + card.getBoundingClientRect().left - track.getBoundingClientRect().left - padding, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        });
      });
      track.addEventListener('scroll', update, {passive: true});
      section.querySelectorAll('[data-mt-video]').forEach(function(link) {
        link.addEventListener('click', function(event) {
          event.preventDefault();
          cards.forEach(reset);
          document.querySelectorAll('.mt-podcast audio').forEach(function(audio) { audio.pause(); });
          const frame = document.createElement('iframe');
          frame.src = 'https://www.youtube.com/embed/' + encodeURIComponent(link.dataset.mtVideo) + '?autoplay=1&rel=0';
          frame.title = link.getAttribute('aria-label');
          frame.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
          frame.allowFullscreen = true;
          frame.referrerPolicy = 'strict-origin-when-cross-origin';
          link.hidden = true;
          link.parentElement.appendChild(frame);
          frame.focus();
        });
      });
      document.addEventListener('play', function(event) {
        if (event.target instanceof HTMLAudioElement && event.target.closest('.mt-podcast')) cards.forEach(reset);
      }, true);
      update();
    });
  }
  initializeMichelleWatch(document);
  document.addEventListener('shopify:section:load', function(event) { initializeMichelleWatch(event.target.parentElement || document); });

  } catch(e) { console.error(e); }
})();
})();
